// import Nfse from './Index.vue'
import Permissions from "../../models/Permissions";

const Relatorios = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

const meta = {
  requiresAuth: true,
  requiresCompany: true,
  showInMenu: true,
  label: "Sefaz/CTE/NFE",
  icon: "fa fa-files-o",
  group: "Arquivos",
  permissions,
};

export default [
  {
    path: "/sefaz_cte_nfe",
    name: "Sefaz/Cte/Nfe",
    component: Relatorios,
    meta,
  },
];
